import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";

interface UserMasterFormProps {
  validation: any;
  userTypes?: any[];
  onUsernameChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneNoChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEmailIdChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const UserMasterForm: React.FC<UserMasterFormProps> = ({
  validation,
  userTypes = [],
  onUsernameChange,
  onPhoneNoChange,
  onEmailIdChange,
}) => {
  const userTypeOptions = userTypes
    .filter((userType) => userType.status === "Active")
    .map((userType) => ({
      label: userType.usertypename,
      value: userType.usertypeid,
    }));

  return (
    <Row className="g-3">
      <Col md={12}>
        <Label className="fw-bold mb-1">
          User Type <span className="text-danger">*</span>
        </Label>
        <div style={{ width: "100%" }}>
          <Select
            options={userTypeOptions}
            name="usertypeid"
            placeholder="Select User Type"
            value={userTypeOptions.find((opt) => opt.value === Number(validation.values.usertypeid)) || null}
            onChange={(e: { value: any }) => validation.setFieldValue("usertypeid", e?.value)}
            onBlur={() => validation.setFieldTouched("usertypeid", true)}
            classNamePrefix="react-select"
            className={validation.touched.usertypeid && validation.errors.usertypeid ? "react-select-error" : ""}
          />
        </div>
        {validation.touched.usertypeid && validation.errors.usertypeid && (
          <div className="invalid-feedback d-block">{validation.errors.usertypeid}</div>
        )}
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Username <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="username"
          placeholder="Enter Username"
          value={validation.values.username || ""}
          onChange={onUsernameChange || validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={
            !!(validation.touched.username && validation.errors.username)
          }
        />
        <FormFeedback>{validation.errors.username}</FormFeedback>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Password <span className="text-danger">*</span>
        </Label>
        <Input
          type="password"
          name="password"
          placeholder="Enter Password"
          value={validation.values.password || ""}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={
            !!(validation.touched.password && validation.errors.password)
          }
        />
        <FormFeedback>{validation.errors.password}</FormFeedback>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Phone Number <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="phone_no"
          placeholder="Enter Phone Number (6-10 digits)"
          value={validation.values.phone_no || ""}
          onChange={onPhoneNoChange || validation.handleChange}
          onBlur={validation.handleBlur}
          maxLength={10}
          invalid={
            !!(validation.touched.phone_no && validation.errors.phone_no)
          }
        />
        <FormFeedback>{validation.errors.phone_no}</FormFeedback>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Email ID <span className="text-danger">*</span>
        </Label>
        <Input
          type="email"
          name="emailid"
          placeholder="Enter Email ID"
          value={validation.values.emailid || ""}
          onChange={onEmailIdChange || validation.handleChange}
          onBlur={validation.handleBlur}
          maxLength={70}
          invalid={
            !!(validation.touched.emailid && validation.errors.emailid)
          }
        />
        <FormFeedback>{validation.errors.emailid}</FormFeedback>
      </Col>
    </Row>
  );
};

export default UserMasterForm;
